import React from "react";
import {
    FacebookIcon,
    FacebookShareButton,
    TwitterIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton
} from "react-share";
import "../styles/yourOrders.css";
import "../styles/artworks.css";
import { DropdownItem, DropdownMenu } from "reactstrap";
import { CopyToClipboard } from 'react-copy-to-clipboard';
// import ReactGA from "react-ga";
export default class ArtistDetails extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
       // ReactGA.pageview('/Share action');
    }

    render() {
        return (
            <DropdownMenu>
                <DropdownItem>
                    <FacebookShareButton url={this.props.share_url}>
                        <FacebookIcon size={32} round={true} />
                        <span className="share-icon-text">Facebook</span>
                    </FacebookShareButton>
                </DropdownItem>
                <DropdownItem>
                    <TwitterShareButton url={this.props.share_url} >
                        <TwitterIcon size={32} round={true} />
                        <span className="share-icon-text">Twitter</span>
                    </TwitterShareButton>
                </DropdownItem>
                <DropdownItem>
                    <WhatsappShareButton url={this.props.share_url} >
                        <WhatsappIcon size={32} round={true} />
                        <span className="share-icon-text">Whatsapp</span>
                    </WhatsappShareButton>
                </DropdownItem>
                <CopyToClipboard text={this.props.share_url}>
                    <DropdownItem>
                    <span className="share-icon-text">Copy To Clipboard</span>
                    </DropdownItem>
                </CopyToClipboard>



            </DropdownMenu>
        )
    }

}


// WEBPACK FOOTER //
// ./src/helpers/shareTheUrl.js